export const data = {
    name: "Activity",
    layout: [],
};
export default data;